import { MIN_RATING_DISPLAY } from 'constants/review'
import { isOrderPast } from 'lib/order/isUpcoming'

// TODO: Temporary hack to hide reviews for some offers
// This should be removed once we have a proper solution to hide reviews/offer via admin portal
// https://aussiecommerce.atlassian.net/browse/CRO-3528
const HIDE_OFFER_REVIEW_LIST:Array<string> = [
  '0062y00000Gxw3FAAR',
]

export function checkOrderAcceptsReview(order?: App.Order) {
  if (!order) return false

  const isTravelledOrder = isOrderPast(order)
  const isValidOrderType = !!(order.items.length || order.tourItems.length || order.experienceItems.length || order.bedbankItems.length)
  const isCompletedItem = isOrderItemCompleted(order)

  return isTravelledOrder && isValidOrderType && isCompletedItem
}

/**
 * For now we're only getting the first item inside order to leave reviews
 * So we get only 1 review by order. For this reason, we check status of the first item
 */
export const isOrderItemCompleted = (order: App.Order): boolean => {
  return !!order.items.length && order.items[0].status === 'completed' ||
    !!order.bedbankItems.length && order.bedbankItems[0].status === 'completed' ||
    !!order.tourItems.length && order.tourItems[0].status === 'completed' ||
    !!order.experienceItems.length && order.experienceItems[0].status === 'completed'
}

export const hideReviewForOffer = (offerId: string): boolean => {
  return HIDE_OFFER_REVIEW_LIST.includes(offerId)
}

export const showUserReviewsRating = (offerId: string, rating?: number, reviewsTotal?: number): boolean => {
  if (!rating || !reviewsTotal) return false

  return (reviewsTotal >= 5 || rating >= MIN_RATING_DISPLAY) && !hideReviewForOffer(offerId)
}

export const getRecommendsLabel = (review: App.Review) => {
  const label = review.rating >= 6 ? 'Recommends' : 'Does not recommend'
  if (review.experienceId) return label + ' this experience'
  if (review.tourId) return label + ' this tour'

  return label + ' this hotel'
}
